<template>
  <Quiz />
</template>

<script>
import Quiz from '@/components/quiz'
import { getCurrentInstance, provide } from 'vue'

export default {
  name: 'App',
  components: {
    Quiz
  },
  setup () {
    provide('pageInfo', getCurrentInstance().appContext.config.globalProperties.initData)
  }
}
</script>
